export default "__VITE_ASSET__649600e4__"